import { PreferenceTools } from '../../tools/preference-tools';

/**
 * One persisted setting: its name in SOL's own key space, and how a stored value narrows to its type.
 *
 * The narrowing rides on the key because the key is the only thing that knows what the value should
 * be. Stored values outlive the code that wrote them — a browser cache from an older release, a
 * context that answered with something else — so a shape that no longer fits reads as absent and the
 * default applies, rather than reaching a caller as a wrong value. The store maps these names onto
 * its own backend fields.
 */
export class SolSettingKey<V> {
  public static readonly theme = SolSettingKey.of<string>('theme', PreferenceTools.toStoredString);
  public static readonly locale = SolSettingKey.of<string>('locale', PreferenceTools.toStoredString);
  public static readonly navbarVisible = SolSettingKey.of<boolean>('navbarVisible', PreferenceTools.toStoredBoolean);
  public static readonly detailFixed = SolSettingKey.of<boolean>('detailFixed', PreferenceTools.toStoredBoolean);
  public static readonly detailWidth = SolSettingKey.of<number>('detailWidth', PreferenceTools.toStoredNumber);

  private constructor(
    public readonly name: string,
    public readonly toStored: (value: unknown) => V | undefined,
  ) {}

  public static of<V>(name: string, toStored: (value: unknown) => V | undefined): SolSettingKey<V> {
    return new SolSettingKey<V>(name, toStored);
  }
}
